import type { EventMessage } from './types';

export enum PeriodValue {
  All,
}

export enum ShowUnread {
  No,
  Yes,
}

export enum QueryKey {
  ShowUnread = 'showUnread',
}

export const EMPTY_EVENTS_MESSAGES_LIST: EventMessage[] = [];
export const DEFAULT_PERIODS = [PeriodValue.All, 30, 90, 365];
